import { AfterContentChecked, ChangeDetectorRef, Component, Input, OnInit } from '@angular/core';
import { Acesso } from "../../../core/acesso";
import { PlanejamentoOficina } from '../../../core/planejamento-oficina';

@Component({
    selector: 'acoes-planejamento-oficina',
    templateUrl: './acoes-planejamento-oficina.component.html',
    styleUrls: ['./acoes-planejamento-oficina.component.css']
})
export class AcoesPlanejamentoOficinaComponent implements OnInit, AfterContentChecked {

    @Input() perfilAcesso: Acesso;

    @Input() planejamentoOficina: PlanejamentoOficina;

    openFormCadastro = false;

    constructor(protected drc: ChangeDetectorRef) {
    }

    ngOnInit() {
    }

    ngAfterContentChecked(): void {
        this.drc.detectChanges();
    }


    onGetAdicionar(evento) {
        this.openFormCadastro = evento;
    }

}
